import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import 'datatables.net';
import { authManager } from '../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Base_Url = process.env.REACT_APP_API_BASE_URL;
const limit = 10;
const $ = window.$;


const Category = () => {
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState({ id: '', name: '' });
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const destroyDataTable = useCallback(() => {
        if ($.fn.DataTable.isDataTable('#category')) {
            $('#category').DataTable().clear().destroy();
        }
    }, []);



    const initializeDataTable = useCallback(async () => {
        destroyDataTable();

        $('#category tbody').html(`
      <tr>
        <td colspan="5" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden"></span>
          </div>
        </td>
      </tr>
    `);

        try {
            const response = await authManager.authenticatedFetch(
                `${Base_Url}/shopping/categories/list?status=active&admin=true`
            );

            const json = await response.json();
            const categories = json.result || [];

            const transformed = categories.map((cat, i) => {
                const subCategories = cat.children || [];
                const childCategoryNames = subCategories.flatMap(sub =>
                    (sub.children || []).map(child => child.name)
                );

                return {
                    serial: i + 1,
                    Category: cat.name || '-',
                    SubCategory: subCategories.map(sub => sub.name).join(', '),
                    ChildCategory: childCategoryNames.join(', '),
                    id: cat.id
                };
            });


            $('#category').DataTable({

                data: transformed,
                columns: [
                    { data: 'serial', title: 'S.No', className: 'text-center', orderable: false },
                    { data: 'Category', title: 'Category', orderable: true, width: '20%', },
                    { data: 'SubCategory', title: 'Sub Category', orderable: false, width: '40%', },
                    {
                        data: 'ChildCategory',
                        title: 'Child Category',
                        orderable: false,
                        width: '40%',
                        render: function (data, type, row) {
                            return `<div class="child-category-cell" title="${data.replace(/"/g, '&quot;')}">${data}</div>`;
                        }
                    },
                    {
                        data: 'id',
                        title: 'Action',
                        className: 'text-center',
                        orderable: false,
                        render: (data, type, row) => `
                        <div align="center">
                            <i class="fa-solid fa-eye crsr_pntr action-icon" data-navigate="/categoryView/${row.id}"></i>
                            <i class="fa-solid fa-pen mr-2 crsr_pntr action-icon" data-navigate="/categoryedit/${row.id}"></i>
                        </div>`
                    }
                ],
                pageLength: limit,
                lengthChange: false,
                responsive: true,
                autoWidth: false,
                ordering: true,
                searching: true,
                paging: true,
                destroy: true,
                drawCallback: function () {
                    const tablePosition = document.getElementById('category')?.offsetTop;
                    if (tablePosition !== undefined) {
                        window.scrollTo({ top: tablePosition - 100, behavior: 'smooth' });
                    }
                }
            });
        } catch (error) {
            console.error('Error fetching categories:', error);
            toast.error("Failed to load categories.");
        }
    }, [destroyDataTable]);


    useEffect(() => {
        const table = document.getElementById('category');
        if (!table) return;

        const handleClick = (e) => {
            const target = e.target.closest('[data-navigate], [data-delete-id]');
            if (!target) return;

            if (target.hasAttribute('data-delete-id')) {
                e.preventDefault();
                const id = target.getAttribute('data-delete-id');
                const name = target.getAttribute('data-delete-name');
                setSelectedCategory({ id, name });
                setShowDeleteModal(true);
                return;
            }

            if (target.hasAttribute('data-navigate')) {
                navigate(target.getAttribute('data-navigate'));
            }
        };

        table.addEventListener('click', handleClick);
        return () => table.removeEventListener('click', handleClick);
    }, [navigate]);

    const handleDelete = async () => {
        if (!selectedCategory.id) return;

        try {
            const response = await authManager.authenticatedFetch(
                `${Base_Url}/shopping/categories/${selectedCategory.id}`,
                { method: 'DELETE' }
            );
            const data = await response.json();

            if (response.ok || data.status === 'success') {
                toast.success(data.message || 'Category deleted successfully');
                setShowDeleteModal(false);
                setSelectedCategory({ id: '', name: '' });
                initializeDataTable();
            } else {
                toast.error(data.message || 'Failed to delete category');
            }
        } catch (error) {
            console.error('Delete error:', error);
            toast.error('Something went wrong while deleting the category');
        }
    };

    useEffect(() => {
        initializeDataTable();
    }, [initializeDataTable]);

    return (
        <div>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Category</h1>
                        </div>
                        <div className="col-sm-6 txt_rgt">
                            <button className="btn btn-blue" onClick={() => navigate('/categoryAdd')}>
                                Add Category
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table id="category" className="table table-striped table-bordered txt_lft" width="100%">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Category</th>
                                            <th>Sub Category</th>
                                            <th>Child Category</th>
                                            <th>Action</th>
                                        </tr>

                                    </thead>
                                    <tbody></tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Modal */}
            <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Category</h5>
                            <button type="button" className="close" onClick={() => setShowDeleteModal(false)}>
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            Are you sure you want to delete <strong>{selectedCategory.name}</strong>?
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button className="btn btn-secondary me-2" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                            <button className="btn btn-danger" onClick={handleDelete}>Yes, delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Category;
